import styled from 'styled-components';
import { breakpoints } from '_constants/mediaOptions';

const Header = styled.header.attrs({
    className: 'header',
})`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 10;
    border-bottom: solid 1px rgba(0, 0, 0, 0.07);

    .container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 15px;
        background: rgba(255, 255, 255, 0.67);

        & > a.logo {
            flex: 0.2 1 0;

            ${breakpoints.xs} {
                svg {
                    width: 60px;
                }
            }
        }

        .header-actions {
            width: max-content;
            display: flex;
            gap: 15px;
            flex: 0.1 1 0;

            .btn {
                font-size: 16px;
                white-space: nowrap;

                ${breakpoints.md} {
                    font-size: 14px;
                    padding: 14px 17px;
                }

                &.add-fastex-chain-btn {
                    background: white;
                    border: 2px solid var(--brand);
                    color: var(--brand);

                    svg {
                        width: 25px;
                        height: 25px;
                    }

                    ${breakpoints.xs} {
                        font-size: 11px;
                        padding: 11px 10px;

                        svg {
                            width: 20px;
                            height: 20px;
                        }
                    }
                }
            }
        }
    }
`;

export default Header;
